import { getRequest } from 'src/utils/http';
import { provincesController } from './consts';

export const getProvinces = async (params) => getRequest(`${provincesController}`, params);
